import { Grid, GridItem, Text, VStack, Checkbox } from '@chakra-ui/react';

import type { CoverageSectionProps } from './types';

const HouseholdCoveragesSection = ({
  coverages,
  updateCoverage,
}: CoverageSectionProps) => {
  return (
    <Grid templateColumns="1fr 1fr" gap={4}>
      <GridItem>
        <Text fontWeight="700" mb={3}>
          Household Coverages
        </Text>
        <VStack align="stretch" spacing={2}>
          <Checkbox
            isChecked={coverages.glass_buydown_enabled}
            onChange={(e) =>
              updateCoverage('glass_buydown_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Glass Buy-Down</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.residential_glass_enabled}
            onChange={(e) =>
              updateCoverage('residential_glass_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Residential Glass</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.food_freezer_enabled}
            onChange={(e) =>
              updateCoverage('food_freezer_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Food Freezer</Text>
          </Checkbox>
        </VStack>
      </GridItem>
      <GridItem>
        <Text fontWeight="700" mb={3}>
          Malicious Damage / Burglary
        </Text>
        <VStack align="stretch" spacing={2}>
          <Checkbox
            isChecked={coverages.malicious_damage_enabled}
            onChange={(e) =>
              updateCoverage('malicious_damage_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Malicious Damage</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.residence_burglary_enabled}
            onChange={(e) =>
              updateCoverage('residence_burglary_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Residence Burglary</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.theft_and_burglary_enabled}
            onChange={(e) =>
              updateCoverage('theft_and_burglary_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Theft and Burglary</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.vandalism_on_dwelling_enabled}
            onChange={(e) =>
              updateCoverage('vandalism_on_dwelling_enabled', e.target.checked)
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Vandalism on Dwelling</Text>
          </Checkbox>
          <Checkbox
            isChecked={coverages.vandalism_theft_by_tenants_enabled}
            onChange={(e) =>
              updateCoverage(
                'vandalism_theft_by_tenants_enabled',
                e.target.checked,
              )
            }
            colorScheme="blue"
          >
            <Text fontSize="sm">Vandalism/Theft by Tenants</Text>
          </Checkbox>
        </VStack>
      </GridItem>
    </Grid>
  );
};

export default HouseholdCoveragesSection;
